import * as React from "react";
import * as request from "superagent";
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';

// import { Definition } from "~common/lib/types";
import { APIError } from "~common/lib/types";
import URLManager from "~common/lib/url-manager";
import { Theme } from "@mui/styles";
import LoadingView from "~common/components/loading-view";
import DefinitionFieldSelector from "./definition-field-selector";

import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography
} from "@mui/material";
import { reduce } from "lodash";

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  modalContent: {
    minHeight: 300,
    width: 570,
  },
  modal: {
    minHeight: 300,
    minWidth: 600,
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  extractionDefinition?: any;
  handleCancel?: Function;
  handleComplete?: Function;
  completeButtonText?: string;
  // Grid Spacing is the spacing for the grid that will be honored in the form.  Will default to 8
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  maxDimensions?: number; 
}

type State = {
  status: "loading" | "ready" | "error";
  template?: any;
  error?: any;
  dimensions?: Array<any>;
};

class DataExtractDialog extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: "loading",
      dimensions: [],
    };
  }

  handleCancel = () => {
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  };

  handleComplete = () => {
    const {dimensions} = this.state;
    const {extractionDefinition} = this.props;
    if (this.props.handleComplete) {
      this.props.handleComplete(extractionDefinition, dimensions);
    }
  };

  handleSelectionChange = (srcDef: any, srcDefPath: string | undefined, item: any, checked: boolean) => {
    let {dimensions} = this.state;
    let dimIdx = -1

    // So this means a new checkbox has been selected.
    const currentDim = dimensions.find((dimPath, idx) => {
      if ((srcDefPath||"").indexOf(dimPath) == 0) {
        dimIdx = idx
        return true;
      }
    })


    if (srcDef.allowsMultiples) {

      // Determine whether this should add or remove from the dimensions array.
      if (checked) {
        // We are adding
        // See if the item is already in the dimensions array.
        if (currentDim) {
          // This dimension is already in the dimensions array, so no need to add it.
        } else {
          // This dimension is not in the dimensions array, so add it.
          if (dimensions) {
            dimensions.push(srcDefPath);
            this.setState({dimensions});
          }
        }


      } else {
        // We are removing
        if (currentDim) {
          // Need to see if there are any other items in the dimensions array that are children of this dimension.
          var anyFieldsSelected: Array<any> = reduce(srcDef.predefined, (acc, field) => {
            if(field.selected) {
              acc.push(field.key)
            }
            return acc;
          }, [])

          if(anyFieldsSelected.length == 0){
            // This dimension is in the dimensions array, so remove it.
            if (dimIdx > -1) {
              if (dimensions) {
                dimensions.splice(dimIdx, 1);
                this.setState({dimensions});
              }
            }
          }
        }

      }

    }




  }

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const {extractionDefinition} = this.props;
    const { status, dimensions } = this.state;

    let selector:any = <DefinitionFieldSelector suppressTitle={true} definition={extractionDefinition} onSelectionChange={this.handleSelectionChange} dimensions={dimensions} maxDimensions={1} />;

    return (
      <Dialog
      className={classes.modal}
      open={true}
      onClose={this.handleCancel}
    >
      <DialogTitle>Extract Data from Results</DialogTitle>
      <DialogContent
        style={{ minHeight: 300, minWidth: 300, paddingRight: 0 }}
        className={classes.modalContent}
      >
          <Typography variant="subtitle1" gutterBottom>
            Please select the fields that you would like to extract from the results.  Note:  You will be limited to one area that allows multiples, such as insurance policies, diversity certificates, etc.
          </Typography>
          <div>{selector}</div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={this.handleCancel}
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          autoFocus={true}
          onClick={this.handleComplete}
          variant="contained"
          color="secondary"
        >
          Extract 
        </Button>
      </DialogActions>
    </Dialog>
    );

  }
}

export default withStyles(styles)(DataExtractDialog);
